// Utility functions for anonymizing user data for admin view

export const anonymizeName = (name: string | null | undefined): string => {
  if (!name) return "[Redacted]";
  return `User ${name.substring(0, 1)}***`;
};

export const anonymizeText = (text: string | null | undefined): string => {
  if (!text) return "[Redacted]";
  return "[Content Redacted for Privacy]";
};

export const anonymizeEmail = (email: string | null | undefined): string => {
  if (!email) return "[Redacted]";
  const [username, domain] = email.split("@");
  return `${username.substring(0, 2)}***@${domain}`;
};

export const anonymizePhone = (phone: string | null | undefined): string => {
  if (!phone) return "[Redacted]";
  return `***-***-${phone.slice(-4)}`;
};

export const getBlurredImageUrl = (imageUrl: string | null | undefined): string => {
  if (!imageUrl) return "";
  // Return the original URL with a CSS filter applied via inline style
  // The actual blurring will be done via CSS
  return imageUrl;
};

export const anonymizeProfile = (profile: any) => {
  return {
    ...profile,
    first_name: anonymizeName(profile.first_name),
    bio: anonymizeText(profile.bio),
    seeking_description: anonymizeText(profile.seeking_description),
  };
};
